export const changeElementVisibility = (element, show) => {
  if (show) {
    element.className = element.className.replaceAll(' hidden', '');
  } else if (!element.className.includes('hidden')) {
    element.className += ' hidden';
  }
}